import imageIcon from 'assets/icons/image.svg';
import { useState } from 'react';

interface ITableRowImageProps {
  url?: string | null;
  alt?: string;
}

const TableRowImage = ({ url, alt }: ITableRowImageProps) => {
  const [imageError, setImageError] = useState(false);
  return (
    <img
      src={!imageError && !!url ? url : imageIcon}
      alt={alt}
      onError={() => setImageError(true)}
    />
  );
};

export default TableRowImage;
